<template>
    <layout>
        <user/> 

        <v-container fluid>
            <v-row>
                <v-col
                    cols="1"
                >
                    <v-card
                        width="70"
                        flat
                        class="d-flex flex-column align-center"
                    >
                        <!-- <v-expand-transition>
                            <v-btn
                                color="primary"
                                dark
                                fab
                                small
                                @click="showMainMenu"    
                            >
                                <v-icon>
                                    mdi-arrow-left
                                </v-icon>
                                
                            </v-btn>
                        </v-expand-transition>
                        <div
                            class="caption mt-2"
                        >
                            Main Menu
                        </div> -->
                    </v-card>
                </v-col>

                <v-col cols="11">
                    <v-row>
                        <v-col
                            v-for="(item, i) in menuItems"
                            :key="i"
                            class="flex-grow-0"                
                        >
                            <v-hover>
                                <template v-slot:default=" { hover }">
                                    <v-card
                                        width="220"
                                        height="150"
                                        @click="display(item.option)"
                                        elevation="4"
                                        class="ma-4"
                                    >
                                        <v-card-title
                                            class="d-flex justify-center pb-0"
                                        >
                                            <v-img
                                                :src="item.src"
                                                max-width="50"
                                                height="50"
                                                contain
                                                class="d-flex"
                                            ></v-img>
                                        </v-card-title>
                                        <v-card-title 
                                            class="subtitle-1 d-flex justify-center"
                                        >
                                            {{ item.title }}
                                        </v-card-title>
                                        <v-card-subtitle
                                            class="caption d-flex justify-center"
                                        >
                                            {{ item.subtitle }}
                                        </v-card-subtitle>
                                        <v-fade-transition>
                                            <v-overlay
                                                v-if="hover"
                                                absolute
                                                color="primary"
                                            ></v-overlay>
                                        </v-fade-transition>
                                    </v-card>
                                </template>
                            </v-hover>
                        </v-col>    
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

       
                  
    </layout>    
</template>

<script>
import { mapGetters } from 'vuex';
import Layout from './layouts/App';
import User from './User';
export default {
    name: 'Dashboard',
    components: {
        Layout,
        User,            
    },       
    computed: {
        ...mapGetters({            
            user: 'auth/getUser',
            admin: 'auth/getAdmin'            
        }),
       
    },

    mounted(){       
        //
    },    
    data: () => ({
        menuItems: [
            {
                icon: 'mdi-pencil',
                title: 'Report Cards',
                subtitle: '',
                src: require('../assets/icons/term-reports.png'),
                option: 'reportCards',
                display: false
            },
            // {
            //     icon: 'mdi-pencil',
            //     title: 'CSEC Subject Selection',
            //     subtitle: '',
            //     src: require('../assets/icons/subject-assignment.png'),
            //     option: 'csecSubjectSelection',
            //     display: false
            // },
           
        ],
        mainMenu: false,
    }),
    methods: { 
        display (menu) {
            switch(menu){
                case 'reportCards':
                    this.$router.push('/term-reports');
                    break;
                case 'csecSubjectSelection':
                    this.$router.push('/csec-subject-selection');
                    break;
                default:
                    break;
            }
        }
           
    }

   
    
}
</script>

<style scoped>
    .v-card{
        cursor: pointer;
    }
</style>